import * as Sentry from "@sentry/react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/hooks/useAuth";
import RequireAuth from "@/components/RequireAuth";
import AppLayout from "@/components/AppLayout";
import Index from "./pages/Index";
import Races from "./pages/Races";
import RaceDetail from "./pages/RaceDetail";
import Results from "./pages/Results";
import Leagues from "./pages/Leagues";
import LeagueDetail from "./pages/LeagueDetail";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";
import RequireAdmin from "@/components/RequireAdmin";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Onboarding from "./pages/Onboarding";
import NotFound from "./pages/NotFound";
import VerifyEmail from "./pages/VerifyEmail";
import JoinLeague from "./pages/JoinLeague";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Disclaimer from "./pages/Disclaimer";
import PageViewTracker from "@/components/PageViewTracker";

const queryClient = new QueryClient();

const App = () => (
  <Sentry.ErrorBoundary fallback={<p>Something went wrong. Please refresh the page.</p>}>
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <PageViewTracker />
          <Routes>
            <Route element={<AppLayout />}>
              <Route path="/" element={<RequireAuth><Index /></RequireAuth>} />
              <Route path="/races" element={<Races />} />
              <Route path="/races/:id" element={<RequireAuth><RaceDetail /></RequireAuth>} />
              <Route path="/results" element={<RequireAuth><Results /></RequireAuth>} />
              <Route path="/leagues" element={<RequireAuth><Leagues /></RequireAuth>} />
              <Route path="/leagues/:id" element={<RequireAuth><LeagueDetail /></RequireAuth>} />
              <Route path="/profile" element={<RequireAuth><Profile /></RequireAuth>} />
              <Route path="/admin" element={<RequireAdmin><Admin /></RequireAdmin>} />
            </Route>
            <Route path="/join/:inviteCode" element={<JoinLeague />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/sign-in" element={<SignIn />} />
            <Route path="/sign-up" element={<SignUp />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
  </Sentry.ErrorBoundary>
);

export default App;
